module.exports = __webpack_public_path__ + "img/check-bullet.85704781.svg";